<template>
	<div class="problem-tag">
		<span class="element">{{ problemId }}</span>
		<span class="element">{{ problemName }} </span>
		<b-icon icon="x-circle-fill" variant="danger" scale="1.3" @click="removeFromPool(problemId)" class="problem-tag-remove" :id="'problem-tag-remove-'+problemId"></b-icon>
	</div>
</template>
<script>

export default {
	name: 'problem-tag',
	props: ['problemId', 'problemName'],
	methods: {
		removeFromPool(problemId) {
			this.$emit('remove', problemId)
		}
	}
}

</script>
<style scoped>
.problem-tag {
	background-color: lightgrey;
	padding: 0.2em 1em;
	font-weight: bold;
	margin: 0.2em;
}

.element {
	padding-right: 1em;
}

.problem-tag-remove {
	cursor: pointer;
}
</style>